export default __webpack_public_path__ + "static/media/elogs_white.9461c248.png";